import React from 'react';

import Header from './partials/Header';

import Products from './product/Products';
import Video from './product/Video';
import Nature from './product/Nature';
import Brands from './partials/Brands';
import SkinStories from './product/SkinStories';
import Faq from './product/Faq';
import Reviews from './partials/Reviews';
import RelatedProduct from './product/RelatedProduct';


import Footer from './partials/Footer';

function Product() {
  return (
    <div className="Product">
        <Header/>
            <Products/>
            <Video/>
            <Brands/>
            <Nature/>
            <SkinStories/>
            <Faq/>
            <Reviews/>
            <RelatedProduct/>
        <Footer/>
    </div>
  );
}

export default Product;
